export default __webpack_public_path__ + "static/media/1188.a747c72f.png";